import { createFileRoute } from '@tanstack/react-router';
import ClaimsPage from '../../components/pages/claims/claims';
import { requireAccess } from '../../auth/authUtils';

export const Route = createFileRoute('/claims/')({
  component: ClaimsPage,
  head: () => ({
    meta: [
      {
        title: 'Claims | Ingle Lewer',
      },
    ],
  }),
  beforeLoad: async ({ context }) => {
    requireAccess(context);
  },
});
